import { render, staticRenderFns } from "./ModalCache.vue?vue&type=template&id=12d4435f&scoped=true"
import script from "./ModalCache.vue?vue&type=script&lang=js"
export * from "./ModalCache.vue?vue&type=script&lang=js"
import style0 from "./modal-notification.scss?vue&type=style&index=0&id=12d4435f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4435f",
  null
  
)

export default component.exports